import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthSyncService } from '../../services/auth-sync.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="error-container">
      <div class="error-content">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h1>{{ errorTitle }}</h1>
        <p>{{ errorMessage }}</p>
        <div class="error-actions">
          <button mat-raised-button color="primary" (click)="retry()">
            <mat-icon>refresh</mat-icon>
            Retry
          </button>
          <button mat-raised-button (click)="logout()">
            <mat-icon>logout</mat-icon>
            Logout
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .error-container {
      display: flex;
      justify-content: center;
      align-items: center;
      //height: 10vh;
      background-color: var(--mat-sys-on-primary);
      padding-top: 120px;
    }

    .error-content {
      text-align: center;
      padding: 3rem;
      background: var(--mat-sys-surface-container-low);
      border-radius: var(--mat-sys-corner-medium);
      box-shadow: var(--mat-sys-level2);
      max-width: 600px;
      width: 100%;
    }

    .error-icon {
      font-size: 80px;
      width: 80px;
      height: 80px;
      color: var(--mat-sys-error);
      margin-bottom: 1rem;
    }

    h1 {
      color: var(--mat-sys-on-surface);
      margin-bottom: 0.5rem;
      font-size: var(--mat-sys-headline-medium-size);
      font-weight: var(--mat-sys-headline-medium-weight);
      line-height: var(--mat-sys-headline-medium-line-height);
    }

    p {
      color: var(--mat-sys-on-surface-variant);
      margin-bottom: 2rem;
      line-height: 1.6;
      font-size: var(--mat-sys-body-large-size);
    }

    .error-actions {
      display: flex;
      gap: 1rem;
      justify-content: center;
      flex-wrap: wrap;
    }

    button {
      gap: 0.5rem;
    }
  `]
})
export class ErrorComponent implements OnInit {
  private router = inject(Router);
  private authSync = inject(AuthSyncService);

  errorTitle = 'Unable to Load User Permissions';
  errorMessage = 'We encountered an error while loading your user permissions. This may be due to a network issue or a problem with the server. Please try again.';

  ngOnInit() {
    // Check if there's a custom error message from navigation state
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;

    if (state?.message) {
      this.errorMessage = state.message;
    }

    if (state?.title) {
      this.errorTitle = state.title;
    }
  }

  retry() {
    // Reload the entire app to trigger APP_INITIALIZER again
    window.location.href = '/';
  }

  logout() {
    // Use Keycloak logout to properly clear the session (and sign out peer tabs)
    this.authSync.logout();
  }
}
